export enum TaskListStatus {
  PLANNED = "PLANNED",
  IN_USE = "IN_USE",
  CLOSED = "CLOSED",
}
